import { render } from "./App.vue?vue&type=template&id=c119a12c"
const script = {}

import exportComponent from "/Users/renzhenxiang/workspace/hd-edu-work/mail-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__